var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.475 5.93962V9.80214C14.475 12.1121 13.155 13.1021 11.175 13.1021H4.58247C4.24497 13.1021 3.92247 13.0722 3.62247 13.0047C3.43497 12.9747 3.25497 12.9222 3.08997 12.8622C1.96497 12.4422 1.28247 11.4671 1.28247 9.80214V5.93962C1.28247 3.62962 2.60247 2.63965 4.58247 2.63965H11.175C12.855 2.63965 14.0625 3.35214 14.385 4.97964C14.4375 5.27964 14.475 5.58712 14.475 5.93962Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7258 8.18947V12.052C16.7258 14.362 15.4058 15.352 13.4258 15.352H6.83329C6.27829 15.352 5.7758 15.277 5.3408 15.112C4.4483 14.782 3.84079 14.0995 3.62329 13.0045C3.92329 13.072 4.24579 13.102 4.58329 13.102H11.1758C13.1558 13.102 14.4758 12.112 14.4758 9.80199V5.93947C14.4758 5.58697 14.4458 5.27199 14.3858 4.97949C15.8108 5.27949 16.7258 6.28447 16.7258 8.18947Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87381 9.85455C8.96733 9.85455 9.85382 8.96807 9.85382 7.87454C9.85382 6.78102 8.96733 5.89453 7.87381 5.89453C6.78029 5.89453 5.8938 6.78102 5.8938 7.87454C5.8938 8.96807 6.78029 9.85455 7.87381 9.85455Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58496 6.22461V9.52463",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 6.22461V9.52463",
    stroke: "#2B2B2B",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPayment);
export default __webpack_public_path__ + "static/media/addPayment.53d6f5f119db1991ac566718388a7b20.svg";
export { ForwardRef as ReactComponent };